import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const FolderCardHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  min-width: 220px;
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: ${Colors.primaryAccent};
  }

  &.selected {
    border-color: ${Colors.primaryAccent};
    background: ${Colors.extraLightPrimary};
    box-shadow: 0 0 0 2px ${Colors.primary}33;
  }

  /* A file is being dragged onto this folder — make it obvious the files will
     be saved inside it. */
  &.drag-over {
    border-color: ${Colors.primaryAccent};
    border-style: dashed;
    background: ${Colors.extraLightPrimary};
    box-shadow: 0 0 0 3px ${Colors.primary}40;
    transform: scale(1.02);
  }

  &.is-skeleton {
    cursor: default;
    pointer-events: none;
  }
  &.is-skeleton:hover {
    border-color: ${Colors.border};
  }

  .folder-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;

    /* Icon and image share the exact same fixed box so the card never
       reflows depending on whether a brand has an avatar. */
    .folder-icon,
    .folder-image {
      width: 32px;
      height: 32px;
      flex-shrink: 0;
      border-radius: 4px;
    }

    .folder-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: ${Colors.primaryAccent};
    }

    .folder-image {
      object-fit: cover;
    }

    .folder-text {
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 0;

      .folder-name {
        font-weight: 500;
        color: ${Colors.textStrong};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .folder-items {
        font-size: 12px;
        color: ${Colors.textMuted};
      }
    }
  }

  .folder-menu {
    color: ${Colors.textMuted};
    cursor: pointer;
    padding: 4px;

    &:hover {
      color: ${Colors.textStrong};
    }
  }
`

export default FolderCardHolder
